export default "__VITE_ASSET__B97knMms__"